<template>
  <CompanySearchSelect
    v-model="selectedCompanyId"
    placeholder="Company..."
  />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch, type Ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAssignmentStore } from '@/store/assignment'
import CompanySearchSelect from '@/views/Components/Elements/Form/CompanySearchSelect.vue'

export default defineComponent({
  name: 'CompanyFilter',
  components: { CompanySearchSelect },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const assignmentStore = useAssignmentStore()

    const selectedCompanyId: Ref<string | null> = ref(null)

    onMounted(() => {
      const companyId = route.query.companyId
      if (companyId) {
        selectedCompanyId.value = String(companyId)
      }
    })

    watch(selectedCompanyId, (newVal) => {
      const query = { ...route.query }
      if (newVal) {
        query.companyId = newVal
      } else {
        delete query.companyId
      }
      router.push({ query })
      assignmentStore.updateAssignmentsFilter({ companyId: newVal || null })
    })

    return { selectedCompanyId }
  },
})
</script>

